import { render } from "./WildBook.vue?vue&type=template&id=601889b2&ts=true"
import script from "./WildBook.vue?vue&type=script&lang=ts"
export * from "./WildBook.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__